/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReferralDetailView.vue?vue&type=template&id=11b2201e&scoped=true"
import script from "./ReferralDetailView.vue?vue&type=script&lang=js"
export * from "./ReferralDetailView.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetailView.vue?vue&type=style&index=0&id=11b2201e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2201e",
  null
  
)

export default component.exports